<template>
  <div class="paper-dialog" @mousewheel="mousewheel" v-if="dialogShow">
    <div class="dialog-inner">
      <img
        class="close-img"
        src="../../assets/img/icon/close.png"
        alt=""
        @click="closeDialog"
      />
      <div class="dia-text">
        您还有 <span class="total">{{ count }}</span> 题未作答，是否提前交卷？
      </div>
      <div class="dia-btns">
        <div class="btn" @click="closeDialog">取消</div>
        <div class="btn btn1" @click="handleSubmit">提前交卷</div>
        <div class="btn btn2" @click="closeDialog">继续作答</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogShow: false,
    };
  },
  props: {
    // 题目数据
    count: {
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.dialogShow = true;
    },
    closeDialog() {
      this.dialogShow = false;
    },
    handleSubmit() {
      this.dialogShow = false;
      this.$emit("submit");
    },
    mousewheel(e) {
      e.preventDefault();
    },
  },
};
</script>
<style lang="less" scoped>
.paper-dialog {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 22;
  background-color: rgba(0, 0, 0, 0.6);
  .dialog-inner {
    position: relative;
    padding-right: 32px;
    width: 480px;
    height: 192px;
    border-radius: 8px;
    opacity: 1;
    background: #fff;
    box-sizing: border-box;
    .close-img {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    .dia-text {
      padding-top: 64px;
      font-weight: bold;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      color: #333333;
      .total {
        color: #ff5536;
      }
    }
    .dia-btns {
      margin-top: 38px;
      display: flex;
      align-items: center;
      justify-content: right;
      .btn {
        margin-right: 8px;
        width: 88px;
        height: 32px;
        border-radius: 16px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f2f2f2;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
      }
      .btn1 {
        border: 1px solid #00b861;
        background: #fff;
        color: #00b861;
      }
      .btn2 {
        background-color: #00b861;
        color: #fff;
      }
    }
  }
}
</style>
